import 'jquery-touch-events';
import 'lightcase';


export function configurePublicLightcase() {
  jQuery(document).ready(function ($) {

    var resizeTimer;

    $(window).on('resize', function(e) {

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {

        $('iframe').css('width', '100%');

      }, 250);

    });

    var doc = document;
    var md = new MobileDetect(window.navigator.userAgent);
    var _shrink = 2;
    var _force = true;
    var _iWidth = $(window).width() - 200;
    var _iHeight = $(window).height();
    var changeWidth = false;
    var changeMargins = false;
    var _width = 800, _height = 500, _iframeWidth = 800, _iframeHeight = 500;
    if (md.mobile() !== "" && md.mobile() !== null) {
      _width = $(window).width() - 20;
      _height = $(window).innerHeight() + 60;
      _iframeHeight = _height - 200;

      var _iWidth = $(window).width() - 120;
      if (md.phone()) {
        _iWidth = $(window).width() - 90;

      }
      var _iHeight = $(window).innerHeight() - 30;
      _shrink = .75;
      _force = true;
      changeWidth = true;
      if (md.os() === "iOS") {
        changeMargins = true;
      }

    }

    $('a[data-rel^=lightcase]').lightcase({
      swipe: true,
      fullscreenModeForMobile: false,
      liveResize: true,
      maxWidth: 1200,
      maxHeight: 1000,
      width: _iWidth,
      height: _iHeight,
      showCaption: false,
      shrinkFactor: _shrink,
      forceWidth: true,
      fixedRatio: true,
      iframe: {
        width: _iWidth,
        height: _iHeight+150,
      },
      onStart: {
        setSource: function() {
          let lightboxphoto = document.getElementById('lightcase-case').getElementsByTagName('img')[0];
          if (lightboxphoto) {
            let currSource = lightboxphoto.getAttribute('data-src');
            let timeStamp = new Date().getTime().toString();
            lightboxphoto.src = currSource + '?t=' + timeStamp;
          }
        },
        setImageSize: function () {
          if (lightcase.getObjectData().type !== 'inline') {
            return;
          }

          let type = lightcase.getObjectData().type;
          let url = lightcase.getObjectData().url;
          let imgHolder = $(url).find('.image-holder')[0];
          let image;
          if (type === 'inline') {
            image = $(url).find('img')[0];
          }

          if (!image) {
            return false;
          }
          if ($(image)[0].naturalWidth - $(image)[0].naturalHeight > 50) {
            $(imgHolder).addClass('image-landscape');
          } else {
            $(imgHolder).removeClass('image-landscape');
          }

          $(image).on('load', function() {
            if ($(image)[0].naturalWidth - $(image)[0].naturalHeight > 50) {
              $(imgHolder).addClass('image-landscape');
            } else {
              $(imgHolder).removeClass('image-landscape');
            }
          });
        }
      },
      onBeforeCalculateDimensions : {
        setPrintButton: function () {
            if(!$('.lightcase-contentInner iframe').length){
              $('.js-lightcase-print-btn').remove();
              $('#lightcase-title').before('<button type="button" class="js-lightcase-print-btn lightcase-print-btn" title="Print this document">print</button>');
              $('.js-lightcase-print-btn').on('click', function () {
                window.print();
              });
            } else {
              $('.js-lightcase-print-btn').remove();
            }
        },
      },
      onCleanup : {
        cleanPrintBtn: function() {
          $('.js-lightcase-print-btn').remove();
        }
      }
    });
  });
};

export default configurePublicLightcase;




// WEBPACK FOOTER //
// ./resources/assets/js/public-lightcase.js